import InfiniteScroll from "../../assets/blogs/infinite-scrolling.jpeg";
import GoogleAuth from "../../assets/blogs/google-auth.png";
import JSPromises from "../../assets/blogs/js-promises.png";
import BreakFree from "../../assets/blogs/breakfree.avif";
import Calendar from "../../assets/blogs/calendar.png";

let BlogsList = [
  {
    title: "How to Build a Week View UI for Your Calendar App",
    img: Calendar,
    href: "https://omgate.hashnode.dev/how-to-build-a-week-view-ui-for-your-calendar-app",
  },
  {
    title: "How to implement Infinite Scrolling with IntersectionObserver API",
    img: InfiniteScroll,
    href: "https://omgate.hashnode.dev/how-to-implement-infinite-scrolling-with-intersectionobserver-api",
  },
  {
    title: "Let's talk about JavaScript Promises Methods",
    img: JSPromises,
    href: "https://omgate.hashnode.dev/lets-talk-about-javascript-promises-methods",
  },

  {
    title: "How to Integrate Firebase Google Auth in your React App",
    img: GoogleAuth,
    href: "https://omgate.hashnode.dev/how-to-integrate-firebase-google-auth-in-your-react-app",
  },

  {
    title: "BreakFree : Where Digital Balance Begins!",
    img: BreakFree,
    href: "https://omgate.hashnode.dev/breakfree-where-digital-balance-begins",
  },
];

export default BlogsList;
